// extracted by mini-css-extract-plugin
export default {"container":"container___eZeMZ","FForbid":"FForbid___SURWp","content":"content___Uk0jP"};